<template>
  <div class="row">
    <div class="col-12 setting">
      <div class="row">
        <SearchForm :users="userOptions" @apply="applySearch" :handleIndicating="handleIndicating" :indicating="indicating"></SearchForm>
        <div class="col-12" v-if="isGemPagesMixed && shouldDisplayMessage">
          <Noti
            class="mb-3"
            type="infor"
            htmlDesc="Activity log will soon be available for pages created with GemPages 7.0"
            :isInline="true"
            :isClose="true"
            @onClose="closeMessage"
          >
          </Noti>
        </div>
        <InfiniteScroll
          @infinite="infiniteHandler"
          :busy.sync="loading"
          :disabled.sync="flagFullEvents"
          :distance="50"
          class="full-width"
        >
          <EventList
            :items="events"
            :loaded="!loading"
            :skeletonLoading="skeletonLoading"
            :no-activities="noActivities"
          ></EventList>
        </InfiniteScroll>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { actions } from "@/store/log/types";
import EventList from "./EventList";
import SearchForm from "./SearchForm";
import InfiniteScroll from "@/core/shared/InfiniteScroll.vue";
import Noti from "@/core/shared/base/Notification"

export default {
  components: {
    Noti,
    EventList,
    SearchForm,
    InfiniteScroll,
  },
  data: () => ({
    events: [],
    users: [],
    userOptions: [],
    loading: true,
    skeletonLoading: true,
    noActivities: false,
    flagFullEvents: false,
    params: null,
    indicating: false,
    shouldDisplayMessage: false
  }),
  computed: {
    isGemPagesMixed() {
      return (this && this.shopInfo && this.shopInfo.isGemPagesV7 === 'mixed') || window.___gemShopInfo.isGemPagesV7 === 'mixed';
    }
  },
  async created() {
    const {
      data: { users },
    } = await this.fetchAssociatedUsers();
    this.userOptions = users.map((e) => ({
      text: this.getLogUserName(e.first_name, e.last_name),
      value: e.id,
    }));
    this.users = users;
    this.infiniteHandler();

    const hasGotMessage = localStorage.getItem('gotMessageEventLog');
    this.shouldDisplayMessage = !hasGotMessage;
  },
  methods: {
    ...mapActions("log", {
      fetchAssociatedUsers: actions.LOG_FETCH_USER,
      fetchEvents: actions.LOG_FETCH_EVENT,
    }),
    handleIndicating(data) {
      if(!data) {
        this.indicating = true;
      }
    },
    async applySearch(data) {
      this.params = {
        query: data.query,
        from_date: data.from,
        to_date: data.to,
        event_type: data.activity,
        user_id: data.user,
      };
      this.skeletonLoading = true;
      this.flagFullEvents = false;
      this.events = [];
      this.page = 1;
      this.resetInfiniteHandler();
      this.infiniteHandler();
    },
    infiniteHandler() {
      if (this.flagFullEvents) {
        return;
      }
      this.loading = true;
      
      this.fetchEvents({ ...this.params, offset: this.events.length })
        .then(({ data: { logs } }) => {
          if (logs.length) {
            logs = logs.map((e) => {
              const user = this.users.find(
                (user) => user.id === e.associated_user_id
              );
              
              return {
                id: e.id,
                user: {
                  name: this.getLogUserName(user.first_name, user.last_name),
                  role: user.actor_type,
                  ip: e.ip_address,
                  email: user.email,
                },
                data: e.data,
                type: e.shop_event,
                description: e.shop_event,
                date: e.started_at,
              };
            });

            const cacheEvents = [];
            logs.forEach((log) => {
              if (!this.events.find((e) => e.id === log.id)) {
                cacheEvents.push(log);
              }
            });
            this.events.push(...cacheEvents);

            //Thêm code check nếu logs trả về <20 (limit) nghĩa là đã hết log
            if(logs.length <20){
              this.flagFullEvents = true;
            }
          } else {
            this.flagFullEvents = true;
          }
        })
        .finally(() => {
          this.skeletonLoading = false;
          this.loading = false;
          this.indicating = false;
          if (!this.events.length) {
            this.noActivities = true;
          }
        });
    },
    getLogUserName(firstName, lastName){
      let userName = (firstName ? firstName: "") + " " + (lastName ? lastName: "");
      userName = userName.trim();
      if(!userName){
        userName = this.$t("storeSettings.eventLogs.unknowUser");
      }
      return userName;
    },
    resetInfiniteHandler() {
      // if (this.$refs.infiniteLoading) {
      //   this.$refs.infiniteLoading.stateChanger.reset();
      // }
    },
    closeMessage() {
      localStorage.setItem('gotMessageEventLog', true);
    }
  },
};
</script>

<style lang="scss" scoped>
.setting {
  &-block {
    .block {
      background: $neutral5;
      height: 100%;

      .icon {
        img {
          width: 40px;
          height: auto;
        }
      }
    }

    .form-group {
      margin-top: 0px !important;
      padding-top: 24px;

      .form-group {
        padding-top: 0px;
      }
    }

    &:not(:first-child) {
      padding-top: 24px;
    }
  }
}
.infinite-scroll {
  max-height: calc(100vh - 400px);
  height: 100vh;
  overflow: overlay;
}
</style>
